const translation = {
  Product: "Producto",
  "Header.productNav": "Producto LUKKEY",
  Feature: "Características",
  "About Us": "Sobre nosotros",
  FAQ: "Preguntas frecuentes",
  "Privacy Policy": "Política de privacidad",
  "Help Center": "Centro de ayuda",
  "Header.infoMenu": "Más",
  "Header.appNow": "Obtener la app",
  "Header.appModal.title": "Usa la app de LUKKEY ahora",
  "Header.appModal.subtitle": "Elige tu plataforma para obtener la app móvil oficial de LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Instala la app oficial en iPhone.",
  "Header.appModal.iosButton": "Abrir",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Obtén la app oficial de Android en Google Play.",
  "Header.appModal.googlePlayButton": "Abrir",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Descarga directamente el APK oficial más reciente.",
  "Header.appModal.androidButton": "Descargar",
  "Header.appModal.note": "Solo descargas móviles oficiales. Usa los enlaces de arriba para obtener la última versión.",
  "Academy": "Academia",
  "Legal": "Legal",
  "AboutUs.title": "Sobre LUKKEY",
  "AboutUs.lede": "LUKKEY es una marca suiza de monederos de hardware dedicada a construir el más alto estándar de seguridad para la propiedad de activos digitales.",
  "AboutUs.vision.closing": "Tus llaves. Tus activos. Tu futuro.",
  "AboutUs.quote": "LUKKEY crea la capa de seguridad entre las personas y los activos digitales.",
  "AboutUs.block1": "LUKKEY tiene su base en Suiza. Se centra en hardware wallets diseñadas para una autocustodia segura.",
  "AboutUs.block2": "Sus productos combinan elementos seguros, protección contra manipulaciones y una arquitectura totalmente offline. El objetivo es mantener las claves privadas en un entorno aislado.",
  "AboutUs.block3": "El sistema está diseñado sin Wi‑Fi, USB ni dependencia directa de red. El acceso por huella, las herramientas de copia NFC y la amplia compatibilidad de activos lo mantienen práctico en el uso diario.",
  "AboutUs.block5": "LUKKEY sigue un enfoque abierto y auditable para el firmware y el software centrales. Las afirmaciones de seguridad deben poder inspeccionarse y verificarse.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Solicitud de soporte",
  "WarrantySupport.intro": "Por favor completa la información a continuación para enviar tu solicitud de soporte.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Resumen del problema",
  "WarrantySupport.form.issueTitle.placeholder": "Introduce un resumen breve",
  "WarrantySupport.form.warrantyType.label": "Tipo de solicitud",
  "WarrantySupport.form.warrantyType.placeholder": "Selecciona el tipo de solicitud",
  "WarrantySupport.form.warrantyType.product": "Problema del dispositivo",
  "WarrantySupport.form.warrantyType.service": "Problema de la app/cuenta",
  "WarrantySupport.form.warrantyType.replacement": "Otro",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Describe el problema o la solicitud en detalle",
  "WarrantySupport.form.submit": "Enviar solicitud de soporte",
  "WarrantySupport.alert.success": "¡Tu solicitud de soporte ha sido enviada!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Centro de ayuda",
  "HelpCenter.intro":
    "¡Bienvenido al Centro de Ayuda de LUKKEY! Si eres nuevo en criptomonedas o necesitas ayuda con tu monedero frío, estás en el lugar correcto. Nuestra solución de monedero frío ofrece la forma más segura de almacenar y gestionar tus activos digitales. A continuación encontrarás respuestas a algunas de las preguntas más comunes y consejos de resolución de problemas.",
  "HelpCenter.section4.title": "¿Necesitas más ayuda?",
  "HelpCenter.section4.intro":
    "Ahorra tiempo iniciando tu solicitud de soporte en línea y te pondremos en contacto con un especialista. Por tu seguridad, el soporte oficial nunca solicitará tu frase de recuperación ni tu clave privada:",
  "HelpCenter.contact.hint": "Usa el botón para enviar una solicitud de soporte y te contactaremos por correo electrónico.",
  "HelpCenter.cta.warranty": "Enviar solicitud de soporte",
  brandName: "LUKKEY",
  tagline: "Administra tu criptomoneda como nunca antes",
  description:
    "Comienza tu viaje hacia la libertad financiera con nuestra aplicación. Asegura tus activos con nuestra avanzada tecnología de billetera fría y gestiona tus finanzas de manera más inteligente y efectiva. Tu bienestar financiero es nuestra prioridad.",
  "home.seoTitle": "LUKKEY | Hardware Wallet suizo para autocustodia segura",
  "home.seoDescription": "LUKKEY es una marca suiza de hardware wallets centrada en la seguridad de cold wallets, la protección offline de claves privadas, el acceso por huella y el respaldo NFC para una autocustodia segura.",
  learnMore: "Saber más",
  "Lock Your Crypto, Securely": "Bloquea tu criptomoneda de manera segura",
  Testimonials: "Testimonios",
  Testimonial1:
    "He estado usando esta billetera fría durante meses y estoy impresionado por su confiabilidad y características de seguridad. ¡Altamente recomendada!",
  Testimonial2:
    "¡Esta billetera fría superó mis expectativas! Su interfaz fácil de usar y su seguridad de primer nivel la convierten en una herramienta imprescindible para cualquiera que se tome en serio las criptomonedas.",
  Testimonial3:
    "He probado varias billeteras frías antes, pero esta se destaca. Su diseño elegante y sus características avanzadas hacen que gestionar mis activos criptográficos sea muy fácil.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Entusiasta de las criptomonedas",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Defensora de la seguridad de las criptomonedas",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analista de inversiones",
  "Touchscreen Interface": "Interfaz táctil",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Disfruta de una gestión de criptomonedas sin esfuerzo con nuestra interfaz táctil intuitiva, diseñada para una navegación rápida y fácil a través de tus activos digitales, permitiendo transacciones rápidas y una gestión segura al alcance de tus manos.",
  "Bluetooth Connectivity": "Conectividad Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Sincronización inalámbrica con tus dispositivos para actualizaciones en tiempo real.",
  "Airtag Tracking": "Seguimiento de Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Rastrea tu billetera fácilmente con el Airtag incorporado.",
  "Secure Chip Technology": "Tecnología de chip seguro",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Equipado con un chip de seguridad avanzado, que garantiza una protección sólida para tus valiosos activos digitales contra accesos no autorizados y amenazas cibernéticas.",
  "Cross-Platform Support": "Soporte multiplataforma",
  "Works with various platforms for easy accessibility.":
    "Funciona con varias plataformas para un fácil acceso.",
  AboutUsDescription1:
    "En LUKKEY, nos dedicamos a proporcionar soluciones de alta calidad para gestionar sus activos en criptomonedas de forma segura.",
  AboutUsDescription2:
    "Nuestra sede está en Zug, Suiza. Con un equipo de profesionales experimentados, nos esforzamos por innovar y adaptarnos al panorama en constante cambio del mercado de monedas digitales.",
  BlockchainNetworksSupported: "Redes Blockchain Soportadas",
  CryptocurrenciesSupported: "Soportando más de 6,000 Criptomonedas",
  Years: "Años",
  ExpertiseInSecurity: "de experiencia en seguridad",
  FrequentlyAskedQuestions: "Preguntas frecuentes",
  WhatIsColdWallet: "¿Qué es un Cold Wallet?",
  ColdWalletDescription:
    "Un cold wallet es un tipo de billetera de criptomonedas que almacena tus activos digitales fuera de línea, lo que hace que sea menos vulnerable a los hacks y otras amenazas en línea. A diferencia de las hot wallets, que están conectadas a Internet y son convenientes para transacciones frecuentes, los cold wallets son más adecuados para almacenamiento a largo plazo, ya que ofrecen una seguridad mejorada.",
  HowToSetUpColdWallet: "¿Cómo configurar tu Cold Wallet?",
  ColdWalletSetupDescription:
    "Configurar tu cold wallet generalmente implica inicializar el dispositivo en una máquina segura y fuera de línea. Necesitarás generar y almacenar de manera segura una frase de recuperación, que es esencial para acceder a tus activos en caso de pérdida o fallo del dispositivo. Las instrucciones detalladas se proporcionan con la compra para garantizar una instalación fluida.",
  CryptocurrenciesCompatibleWithColdWallet:
    "¿Qué criptomonedas son compatibles con tus cold wallets?",
  CryptocurrenciesCompatibilityDescription:
    "Nuestros cold wallets son compatibles con una amplia gama de criptomonedas, incluidas las principales como Bitcoin, Ethereum y Litecoin, así como varias altcoins. Para obtener una lista completa de las monedas compatibles, por favor visita nuestro sitio web o consulta la documentación del producto.",
  HowToSecureColdWallet: "¿Cómo garantizar la seguridad de tu Cold Wallet?",
  ColdWalletSecurityDescription:
    "Para asegurar tu cold wallet, conserva siempre la frase de recuperación en un lugar seguro y privado, no la compartas con nadie, y considera usar medidas de seguridad adicionales como bloqueos biométricos o contenedores seguros. Actualizar regularmente el firmware de la billetera desde el sitio oficial también ayuda a proteger contra vulnerabilidades.",
  ColdWalletNotWorking:
    "¿Qué hacer si mi Cold Wallet no funciona o si encuentro un error?",
  ColdWalletErrorDescription:
    "Si tienes problemas con tu cold wallet, consulta la sección de solución de problemas de nuestra guía de usuario. Para problemas más específicos, contacta con nuestro equipo de soporte a través de nuestro sitio web. Asegúrate de tener la información de tu dispositivo a mano para agilizar el proceso de soporte.",
  Community: "Comunidad",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Únete a nuestra comunidad en tu plataforma favorita para mantenerte actualizado, hacer preguntas y conectar con otros usuarios.",
  "Subscribe.title": "Recibe actualizaciones del producto",
  "Subscribe.subtitle":
    "Seguimos las tendencias cripto por ti. Recibe actualizaciones de producto, análisis de mercado y ventajas exclusivas — directamente en tu bandeja de entrada.",
  "Subscribe.placeholder": "Introduce tu correo electrónico",
  "Subscribe.button": "Suscribirse a actualizaciones del producto",
  "Subscribe.input.aria": "Campo de entrada de correo electrónico",
  "Subscribe.success":
    "¡Gracias por suscribirte! Revisa tu bandeja de entrada para el correo de confirmación.",
  "Subscribe.error": "Error al suscribirse. Inténtalo de nuevo más tarde.",
  "Subscribe.invalid": "Por favor, introduce una dirección de correo válida.",
  "Subscribe.privacy":
    "Tu correo electrónico solo se utilizará para enviarte nuestro boletín y actualizaciones. Puedes darte de baja en cualquier momento mediante el enlace incluido en el boletín.",
  "Subscribe.learnMore":
    "Más información sobre cómo gestionamos tus datos y tus derechos.",
  "Subscribe.popupCompact.title": "Mantente al día",
  "Subscribe.popupCompact.subtitle":
    "Actualizaciones del producto e información de seguridad. Sin spam.",
  "Subscribe.popupCompact.button": "Suscribirse",
  "Subscribe.popupCompact.privacy":
    "Solo correo. Cancela la suscripción cuando quieras.",
  "SubscribeConfirmed.alt.success": "Suscripción confirmada",
  "SubscribeConfirmed.alt.failed": "Suscripción fallida",
  "SubscribeConfirmed.title.success": "Suscripción confirmada",
  "SubscribeConfirmed.title.failed": "Suscripción fallida",
  "SubscribeConfirmed.message.success":
    "Gracias por confirmar tu correo. Tu suscripción ahora está activa. Se ha enviado un correo de bienvenida a tu bandeja de entrada.",
  "SubscribeConfirmed.message.failed":
    "El enlace de confirmación no es válido o ha caducado. Por favor, vuelve a la página de inicio e intenta suscribirte de nuevo.",
  "SubscribeConfirmed.cta.backHome": "Volver al inicio",
  "SubscribeConfirmed.note.unsubscribe":
    "Puedes darte de baja en cualquier momento mediante el enlace incluido en nuestros correos.",
  // ===== MarketView i18n =====
  "MarketView.title": "Panel del mercado",
  "MarketView.loading": "Cargando...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Esta pestaña no se pudo renderizar",
  "MarketView.unknownError": "Error desconocido",

  // ===== Common i18n =====
  "Common.refresh": "Actualizar",
  "Common.toggleSeriesVisibility": "Alternar esta serie",
  "Common.error": "Error",
  "Common.dataUpdateTime": "Hora de actualización de datos",
  "Common.loading": "Cargando...",
  "Common.noDataSource": "Sin datos (no se proporcionó la fuente de datos)",

  // ===== Common ranges =====
  "Common.to": "a",
  "Common.clear": "Limpiar",
  "Common.range.thisMonth": "Este mes",
  "Common.range.lastMonth": "Mes pasado",
  "Common.range.last2": "Últimos 2 meses",
  "Common.range.last3": "Últimos 3 meses",
  "Common.range.last6": "Últimos 6 meses",
  "Common.range.thisYear": "Este año",
  "Common.range.all": "Todos",
  "Common.range.custom": "Personalizado",
  "Common.showFilters": "Mostrar filtros",
  "Common.hideFilters": "Ocultar filtros",
  "Common.search": "Buscar",
  "Common.priority": "Prioridad",
  "Common.owner": "Responsable",
  "Common.collaborator": "Colaborador",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Descargar backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Descargar youtube_stats.json",
  "YouTubeTab.loading": "Cargando métricas de YouTube...",
  "YouTubeTab.errorHint":
    "Si la clave API no está configurada, establezca YOUTUBE_API_KEY o GOOGLE_API_KEY en backend/.env y reinicie el backend.",
  "YouTubeTab.header.totalViews":
    "Reproducciones totales (multicanal, unidad: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Suscriptores totales (multicanal, unidad: 10k)",
  "YouTubeTab.dist.views": "Distribución de reproducciones (10k)",
  "YouTubeTab.dist.subscribers": "Distribución de suscriptores (10k)",
  "YouTubeTab.card.location": "Ubicación:",
  "YouTubeTab.card.registeredAt": "Registrado en:",
  "YouTubeTab.card.currentSubscribers": "Suscriptores actuales",
  "YouTubeTab.card.currentVideos": "Cantidad de videos actual",
  "YouTubeTab.card.currentTotalViews": "Reproducciones totales actuales",
  "YouTubeTab.card.currentTotalComments": "Comentarios totales actuales",
  "YouTubeTab.chart.totalSubscribers": "Suscriptores totales",
  "YouTubeTab.chart.totalViews": "Reproducciones totales",
  "YouTubeTab.chart.totalComments": "Comentarios totales",
  "YouTubeTab.chart.totalVideos": "Videos totales",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Descargar backend data/x_stats.json",
  "XTab.downloadJson": "Descargar x_stats.json",
  "XTab.loading": "Cargando métricas de X...",
  "XTab.errorHint":
    "Si el token no está configurado, establezca X_BEARER_TOKEN o TWITTER_BEARER_TOKEN en backend/.env y reinicie el backend.",
  "XTab.header.totalFollowers": "Seguidores totales (multicanal, unidad: 10k)",
  "XTab.header.totalEngagement":
    "Interacción total (últimos 5 posts: Me gusta + Retweets + Respuestas + Citas, unidad: 10k)",
  "XTab.dist.followers": "Distribución de seguidores (10k)",
  "XTab.dist.engagement":
    "Distribución de interacción (últimos 5 posts: Me gusta + Retweets + Respuestas + Citas, unidad: 10k)",
  "XTab.card.currentFollowers": "Seguidores actuales",
  "XTab.card.currentFollowing": "Siguiendo actualmente",
  "XTab.card.currentTweets": "Cantidad de tweets actual",
  "XTab.card.recentLikes": "Me gusta recientes (últimos 5 posts)",
  "XTab.card.recentRetweets": "Retweets recientes (últimos 5 posts)",
  "XTab.card.recentReplies": "Respuestas recientes (últimos 5 posts)",
  "XTab.card.recentQuotes":
    "Vistas recientes (nivel contenido, últimos 5 posts)",
  "XTab.card.listed": "Veces en listas (nivel canal)",
  "XTab.smallChart.followers": "Seguidores",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Me gusta recientes",
  "XTab.smallChart.retweets": "Retweets recientes",
  "XTab.smallChart.replies": "Respuestas recientes",
  "XTab.smallChart.quotes": "Vistas recientes (nivel contenido)",
  "XTab.smallChart.following": "Siguiendo",
  "XTab.smallChart.listed": "Listados",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Filtrar por mes de creación:",
  "Analytics.dashboardTitle": "Panel de salud del proyecto",
  "Analytics.metric.completionRate": "Tasa de finalización",
  "Analytics.metric.teamVelocity": "Velocidad del equipo",
  "Analytics.metric.blockerRatio": "Proporción de bloqueos",
  "Analytics.metric.workloadBalance": "Equilibrio de carga de trabajo",
  "Analytics.charts.statusDistribution": "Distribución de estados",
  "Analytics.charts.statusByMonthPercent": "Estados por mes (porcentaje)",
  "Analytics.charts.priorityDistribution": "Distribución de prioridades",
  "Analytics.charts.priorityByMonthPercent": "Prioridades por mes (porcentaje)",
  "Analytics.charts.functionTypeDistribution":
    "Distribución por tipo de función",
  "Analytics.charts.functionTypeByMonthPercent":
    "Tipo de función por mes (porcentaje)",
  "Analytics.blocker.ownerPie":
    "Problemas bloqueados · Distribución por responsable (donut)",
  "Analytics.blocker.ownerByMonth":
    "Problemas bloqueados · Responsable por mes (porcentaje)",
  "Analytics.bug.ownerPie":
    "Problemas de bug · Distribución por responsable (donut)",
  "Analytics.bug.ownerByMonth":
    "Problemas de bug · Responsable por mes (porcentaje)",
  "Analytics.ownerWorkloadDistribution":
    "Distribución de la carga de trabajo del equipo",
  "Analytics.mode.priority": "Distribución de prioridades",
  "Analytics.mode.status": "Distribución de estados",
  "Analytics.mode.type": "Distribución por tipo",
  "Analytics.blocker.attentionNeeded":
    "Problemas que requieren atención inmediata",
  "Analytics.common.status": "Estado",
  "Analytics.common.owner": "Responsable",
  "Analytics.insights.sectionTitle": "Información y recomendaciones",
  "Analytics.insights.efficiency.title": "Sugerencias de mejora de eficiencia",
  "Analytics.insights.efficiency.completionRate":
    "• La tasa de finalización actual es {{rate}}%, vigile los bloqueos",
  "Analytics.insights.efficiency.avgVelocity":
    "• La velocidad media del equipo es {{velocity}} tareas/persona",
  "Analytics.insights.efficiency.workloadBalance":
    "• El equilibrio de carga es {{balance}}%",
  "Analytics.insights.risk.title": "Alertas de riesgo",
  "Analytics.insights.risk.blockerRatio": "• Proporción de bloqueos {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Proporción de issues P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Atienda primero los problemas de alta prioridad",

  // ===== Kanban i18n =====
  "Kanban.title": "Vista Kanban",
  "Kanban.totalIssues": "Total {{count}} problemas",
  "Kanban.searchPlaceholder":
    "Buscar título, número de issue, responsable o colaboradores...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "En curso",
  "Kanban.status.blocked": "Bloqueado / Pendiente de confirmación",
  "Kanban.status.reviewTest": "Revisión / Pruebas",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Lista de problemas",
  "List.totalIssues": "Total {{count}} problemas",
  "List.viewDetails": "Ver detalles",
  "List.openInNewWindow": "Abrir en una nueva ventana",
  "List.empty.title": "Sin problemas",
  "List.empty.subtitle":
    "Crea el primer problema para iniciar tu flujo de trabajo",

  // ===== Assets Register i18n =====
  "Assets.title": "Registro de activos",
  "Assets.totalSets": "Conjuntos totales",
  "Assets.table.employee": "Empleado",
  "Assets.table.setCount": "Conjuntos",
  "Assets.table.model": "Modelo",
  "Assets.total": "Total",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Seguimiento de problemas de proyecto",
  "LukkeyIssues.goToDemo": "Ir a la página de demostración",
  "LukkeyIssues.githubProject": "Proyecto de GitHub ↗",
  "LukkeyIssues.githubManageIssues":
    "Gestionar Issues directamente en GitHub ↗",
  "LukkeyIssues.financeModel": "Modelo financiero",
  "LukkeyIssues.productCoreIssues": "Problemas núcleo del producto",
  "LukkeyIssues.stats.totalIssues": "📊 Problemas totales",
  "LukkeyIssues.stats.completed": "✅ Completados",
  "LukkeyIssues.stats.inProgress": "🔄 En progreso",
  "LukkeyIssues.stats.pending": "⏳ Pendientes",
  "LukkeyIssues.stats.blocked": "🚫 Bloqueados",
  "LukkeyIssues.stats.docs": "📚 Documentación",
  "LukkeyIssues.tabs.kanban": "Vista Kanban",
  "LukkeyIssues.tabs.analytics": "Analítica",
  "LukkeyIssues.tabs.market": "Panel del mercado",
  "LukkeyIssues.tabs.assets": "Registro de activos",
  "LukkeyIssues.shareToChatGPT": "Abrir LUKKEY.json con ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Política de Privacidad de LUKKEY",
  "PrivacyPolicy.intro.p1":
    "En LUKKEY, creemos que la forma más segura de privacidad es la que permanece siempre en manos del propio usuario.",
  "PrivacyPolicy.intro.p2":
    "Por lo tanto, tanto si utilizas el hardware de monedero frío (cold wallet) LUKKEY como la aplicación móvil LUKKEY (App), cumplimos estrictamente un principio inquebrantable:",
  "PrivacyPolicy.intro.p3_strong":
    "Salvo autorización explícita del usuario, no recopilamos, almacenamos ni subimos ninguna información del usuario.",
  "PrivacyPolicy.intro.p3_tail":
    "Todos los datos relacionados con el uso se guardan únicamente de forma local en el dispositivo del usuario y nunca se transmiten a LUKKEY ni a ningún servidor.",
  "PrivacyPolicy.intro.p4":
    "Esta Política de Privacidad explica cómo cumplimos este principio.",

  "PrivacyPolicy.s1.title": "1. Ámbito de aplicación",
  "PrivacyPolicy.s1.appliesTo": "Esta Política de Privacidad se aplica a:",
  "PrivacyPolicy.s1.item.hardware": "Hardware de monedero frío LUKKEY",
  "PrivacyPolicy.s1.item.app": "Aplicación móvil LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Ambos siguen el principio unificado de “cero recopilación, cero subida, almacenamiento solo local”.",

  "PrivacyPolicy.s2.title": "2. Información que NO recopilamos",
  "PrivacyPolicy.s2.desc":
    "Para proteger tu privacidad, nos comprometemos explícitamente a no recopilar, subir ni almacenar ninguna información del usuario, incluyendo (entre otras):",
  "PrivacyPolicy.s2.li.identity":
    "Información de identidad: nombre, número de teléfono, correo electrónico, dirección postal",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Datos sensibles del monedero: claves privadas, frases mnemotécnicas, archivos keystore, contraseñas del monedero",
  "PrivacyPolicy.s2.li.blockchain":
    "Datos de blockchain: direcciones de monedero, historial de transacciones, información de activos",
  "PrivacyPolicy.s2.li.behavior":
    "Comportamiento de uso: registros de la app, clics, analítica de comportamiento",
  "PrivacyPolicy.s2.li.technical":
    "Información técnica: identificadores de dispositivo, geolocalización, dirección IP",
  "PrivacyPolicy.s2.inShort.title": "En resumen:",
  "PrivacyPolicy.s2.inShort.desc":
    "Todo lo que ves en el dispositivo hardware y en la App existe únicamente en tu dispositivo. LUKKEY no puede acceder a ello.",

  "PrivacyPolicy.s3.title":
    "3. Diseño de privacidad y seguridad del monedero frío (hardware)",
  "PrivacyPolicy.s3.desc":
    "El cold wallet de LUKKEY proporciona un entorno completamente sin conexión y seguro. Características clave:",
  "PrivacyPolicy.s3.h1.title": "1. Hardware de seguridad de grado militar",
  "PrivacyPolicy.s3.h1.l1": "Secure Element certificado EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Comunicación cifrada a nivel de hardware en toda la cadena",
  "PrivacyPolicy.s3.h2.title": "2. Funciones de seguridad",
  "PrivacyPolicy.s3.h2.l1": "Autenticación por huella dactilar",
  "PrivacyPolicy.s3.h2.l2": "Modo de privacidad",
  "PrivacyPolicy.s3.h2.l3": "Gestión aislada de múltiples monederos",
  "PrivacyPolicy.s3.h3.title": "3. Aislamiento completo",
  "PrivacyPolicy.s3.h3.l1": "Sin conectividad a Internet",
  "PrivacyPolicy.s3.h3.l2": "Sin conexión por cable de datos",
  "PrivacyPolicy.s3.h4.title": "4. Autodestrucción antimanipulación",
  "PrivacyPolicy.s3.h4.desc":
    "Si el dispositivo se desmonta, se daña o sufre una intrusión anómala, el Secure Element destruye automáticamente los datos sensibles para garantizar que no se puedan extraer las claves privadas.",
  "PrivacyPolicy.s3.h5.title":
    "5. Operaciones sensibles solo dentro del Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Creación de monedero",
  "PrivacyPolicy.s3.h5.l2": "Importación de monedero",
  "PrivacyPolicy.s3.h5.l3": "Firma de transacciones",
  "PrivacyPolicy.s3.h5.note":
    "Todos los procesos sensibles ocurren 100% dentro del Secure Element, sin exponerse jamás a chips o áreas de almacenamiento no seguras.",
  "PrivacyPolicy.s3.h6.title":
    "6. Sin datos sensibles fuera del Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Las áreas de almacenamiento no seguras del dispositivo nunca almacenan claves privadas, frases mnemotécnicas ni ninguna información sensible.",

  "PrivacyPolicy.s4.title":
    "4. Diseño de privacidad y seguridad de la App LUKKEY",
  "PrivacyPolicy.s4.desc":
    "La App LUKKEY se centra exclusivamente en mostrar información y proporcionar notificaciones. No maneja datos sensibles del monedero.",
  "PrivacyPolicy.s4.n1.title": "1. Lo que la App NO hace",
  "PrivacyPolicy.s4.n1.l1": "No genera monederos blockchain",
  "PrivacyPolicy.s4.n1.l2": "No importa monederos blockchain",
  "PrivacyPolicy.s4.n1.l3":
    "No almacena claves privadas ni frases mnemotécnicas",
  "PrivacyPolicy.s4.n1.l4": "No sube ningún dato del usuario",
  "PrivacyPolicy.s4.n1.l5":
    "No realiza analítica de comportamiento, seguimiento publicitario ni recolección de datos",
  "PrivacyPolicy.s4.n2.title": "2. Lo que la App SÍ hace",
  "PrivacyPolicy.s4.n2.l1":
    "Muestra información de acceso público autorizada por el hardware",
  "PrivacyPolicy.s4.n2.l2":
    "Proporciona un panel de privacidad que explica el propósito de cada permiso",
  "PrivacyPolicy.s4.n2.l3":
    "Otorga al usuario control total para habilitar/deshabilitar permisos en cualquier momento",
  "PrivacyPolicy.s4.n2.l4": "Ofrece enmascaramiento de información sensible",
  "PrivacyPolicy.s4.n2.l5":
    "Desactiva capturas de pantalla/grabación en determinadas vistas",
  "PrivacyPolicy.s4.n2.l6":
    "Detecta direcciones de blockchain sospechosas mediante coincidencia local",
  "PrivacyPolicy.s4.n2.l7":
    "Actualiza regularmente URL, contratos y direcciones peligrosas",
  "PrivacyPolicy.s4.n2.l8":
    "El flujo de actualización es unidireccional: servidor → dispositivo solamente",
  "PrivacyPolicy.s4.n2.l9":
    "Nunca se envían datos del usuario durante las actualizaciones",
  "PrivacyPolicy.s4.n3.title": "3. Almacenamiento local",
  "PrivacyPolicy.s4.n3.p1":
    "La App solo almacena localmente datos no privados, como preferencias de interfaz, idioma y tema. Estos datos:",
  "PrivacyPolicy.s4.n3.l1": "no se suben",
  "PrivacyPolicy.s4.n3.l2": "no se sincronizan",
  "PrivacyPolicy.s4.n3.l3": "no son accesibles para LUKKEY",

  "PrivacyPolicy.s5.title": "5. Transmisión de datos y política de servidores",
  "PrivacyPolicy.s5.l1":
    "Los servidores de LUKKEY no almacenan ninguna información del usuario",
  "PrivacyPolicy.s5.l2":
    "La comunicación App–servidor se limita a actualizaciones de base de datos y de versión",
  "PrivacyPolicy.s5.l3":
    "No se transmite información del usuario durante la comunicación",
  "PrivacyPolicy.s5.l4":
    "Incluso en caso de una brecha en el servidor, no podría exponerse ningún dato del usuario, porque nunca lo obtenemos",

  "PrivacyPolicy.s6.title": "6. Transparencia de código abierto",
  "PrivacyPolicy.s6.l1":
    "El código fuente de la App LUKKEY es de código abierto",
  "PrivacyPolicy.s6.l2":
    "El firmware embebido del hardware LUKKEY es de código abierto",
  "PrivacyPolicy.s6.l3":
    "Disponible íntegramente en GitHub para que cualquiera lo audite",
  "PrivacyPolicy.s6.p": "La transparencia forma parte de la seguridad.",

  "PrivacyPolicy.s7.title": "7. Control total del usuario",
  "PrivacyPolicy.s7.p":
    "Aunque no recopilamos información del usuario, los usuarios conservan el control total sobre sus dispositivos:",
  "PrivacyPolicy.s7.l1":
    "Puedes desactivar los permisos de la App en cualquier momento",
  "PrivacyPolicy.s7.l2":
    "Puedes desinstalar la App para eliminar todos los datos locales de la aplicación",
  "PrivacyPolicy.s7.l3":
    "Puedes restablecer el dispositivo hardware para borrar permanentemente las claves privadas y los datos del monedero",
  "PrivacyPolicy.s7.p2":
    "LUKKEY no interviene ni puede intervenir en estas acciones.",

  "PrivacyPolicy.s8.title": "8. Contáctanos",
  "PrivacyPolicy.s8.p":
    "Si tienes alguna pregunta sobre esta Política de Privacidad, contáctanos:",
  "PrivacyPolicy.s8.email": "Correo electrónico: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Dirección: Sede de LUKKEY, Baarerstrasse 25, 6300 Zug, Suiza",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Comprobando...",
  "EmailOtp.title":
    "Acceso restringido: introduce tu nombre y correo para obtener un código de inicio de sesión",
  "EmailOtp.nameLabel": "Nombre",
  "EmailOtp.namePlaceholder": "Introduce tu nombre",
  "EmailOtp.emailLabel": "Correo electrónico",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Enviar código",
  "EmailOtp.resendCode": "Reenviar código",
  "EmailOtp.resendWithCountdown": "Reenviar ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "El código de verificación es válido durante unos 10 minutos",
  "EmailOtp.codeLabel": "Código de verificación por correo",
  "EmailOtp.codePlaceholder": "Introduce el código recibido",
  "EmailOtp.signIn": "Iniciar sesión",
  "EmailOtp.message.codeSent":
    "Código de verificación enviado, revisa tu bandeja de entrada",
  "EmailOtp.error.nameRequired": "Introduce tu nombre",
  "EmailOtp.error.invalidEmail": "Introduce un correo electrónico válido",
  "EmailOtp.error.sendFailed":
    "Error al enviar el código de verificación. Inténtalo de nuevo más tarde.",
  "EmailOtp.error.codeRequired": "Introduce el código de verificación",
  "EmailOtp.error.verificationFailed": "La verificación ha fallado",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "Aviso de seguridad: verifica siempre los enlaces y nunca compartas tu frase de recuperación.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Academia",
  "Academy.hero.subtitle":
    "Guías prácticas sobre seguridad cripto, autocustodia y uso del cold wallet de LUKKEY.",
  "Academy.search.placeholder":
    "Buscar tutoriales, buenas prácticas y preguntas frecuentes…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "ARTÍCULO",
  "Academy.list.title": "Últimas guías",
  "Academy.list.viewAll": "VER TODO",
  "Academy.list.empty": "Sin resultados. Prueba con otra palabra clave.",
  "Academy.image.placeholder": "IMAGEN",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Volver a la Academia",
  "AcademyArticle.notFound": "Artículo no encontrado",
  "AcademyArticle.author": "Autor",
  "AcademyArticle.unscheduled": "Sin fecha de publicación programada",
  "home.hero.reserveCtaLabel": "Acceso anticipado — 1 US$",
  "home.hero.reserveCtaNote": "Totalmente reembolsable. Sin compromiso de compra.",
};

export default translation;
